/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type ResolvedScorecardSetResolvedFrom = typeof ResolvedScorecardSetResolvedFrom[keyof typeof ResolvedScorecardSetResolvedFrom];


export const ResolvedScorecardSetResolvedFrom = {
  job: 'job',
  org_default: 'org_default',
  none: 'none',
} as const;
